import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import { useContent } from '../hooks/useContent';
import { useScrollToTop } from '../hooks/useScrollToTop';

const ChemicalProducts = () => {
  useScrollToTop();
  const { chemicalProducts } = useContent();

  return (
    <SimplePage
      title={chemicalProducts.title}
      description={chemicalProducts.description}
    />
  );
};

export default ChemicalProducts;